"use client";

import { useEffect } from "react";

import { logError } from "@/lib/logger";

/**
 * Last-resort boundary for errors thrown by the root layout itself. It
 * replaces the whole document, so it must render <html> and <body> and can't
 * rely on providers, fonts or translations.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logError("Root layout error", error, {
      component: "GlobalErrorBoundary",
      ...(error.digest && { digest: error.digest }),
    });
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          fontFamily: "system-ui, sans-serif",
          background: "#000",
          color: "#fff",
          textAlign: "center",
          padding: "1rem",
        }}
      >
        <main>
          <p aria-hidden style={{ fontSize: "3rem", margin: 0 }}>
            🎬
          </p>
          <h1>Something went wrong</h1>
          <p style={{ opacity: 0.7 }}>
            Cage MDB hit an unexpected error. Please try again.
          </p>
          <button
            style={{
              marginTop: "1rem",
              padding: "0.6rem 1.4rem",
              borderRadius: "999px",
              border: 0,
              background: "#17c964",
              color: "#000",
              fontWeight: 600,
              cursor: "pointer",
            }}
            type="button"
            onClick={reset}
          >
            Try again
          </button>
        </main>
      </body>
    </html>
  );
}
